/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { 
  Sidebar, 
  Menu, 
  MenuItem, 
  SubMenu, 
  useProSidebar 
} from "react-pro-sidebar";
import {
  MenuOutlined, 
  HomeOutlined, 
  ViewArrayOutlined,
  DashboardOutlined, 
  FactoryOutlined,
  ImageOutlined,
  AdminPanelSettingsOutlined,
  SecurityOutlined,
  CheckCircle,
  CancelRounded,
} from "@mui/icons-material";
import { 
  Box, 
  Typography,
} from "@mui/material";

import { 
  useColorModeContext,
  useReportsConfirmed,
  useSidebar, 
  useSidebarContext,
  useTemplateDirectionContext,
} from "../../hooks";
import { ActivateChangeUserPassword } from "../../redux/actionCreators/authActions";
import { RootState } from "../../redux/store/store";
import { IPermission } from "../../models/permission";
import { ColorModeContextType } from "../../context";
import { GetMachineryReport } from "../../redux/actionCreators/machineryActions";
import { GetProjectPersonalReport } from "../../redux/actionCreators/projectPersonalActions";
import { GetProgressStateReport } from "../../redux/actionCreators/progressStateActions";
import { GetHseReport } from "../../redux/actionCreators/hseActions";
import { GetInvoiceReport1, GetInvoiceReport2 } from "../../redux/actionCreators/invoiceActions";
import { GetFinancialInfoReport } from "../../redux/actionCreators/financialInfoActions";
import { GetBudgetCostReport } from "../../redux/actionCreators/budgetCostActions";
import { SetReportVisit } from "../../redux/actionCreators/reportVisitActions";
import { 
  IRequestReportVisit,
} from '../../models/reportVisit';


export const SideBar: FC = (): ReactElement => {
  const { colorMode } = useColorModeContext() as ColorModeContextType;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { confirmedReports } = useReportsConfirmed()

  const { 
    collapsed, 
  } = useProSidebar();
  const { 
    toggle,
    menuItemStyles
  } = useSidebar();
  const { setMenuTitle } = useSidebarContext();
  const { rtl } = useTemplateDirectionContext();

  const userid: number = useSelector((state: RootState) => state.auth.user?.id!)
  const board: boolean = useSelector((state: RootState) => state.auth.board)

  const isAllProjectUser = JSON.parse(localStorage.getItem("isAllProjectUser")!)
  const permissions: IPermission[] = useSelector((state: RootState) => isAllProjectUser 
                                                  ? state.auth.permissions 
                                                  : state.contracts.permissions)

  const currentContractId: number = useSelector((state: RootState) => state.contracts.currentContractId)
  const currentReportDateId: number = useSelector((state: RootState) => state.reportDates.currentReportDateId)
  
  // console.log('====== isAllProjectUser: ', isAllProjectUser)
  // console.log('====== permissions: ', permissions)

  const menuItemMouseUpHandler = (mnuTitle: string) => {
    setMenuTitle(mnuTitle)
  };

  const retrieveDashboardData = useCallback(() => {
    dispatch<any>(GetFinancialInfoReport(currentContractId, currentReportDateId));
    dispatch<any>(GetInvoiceReport1(currentContractId, currentReportDateId));
    dispatch<any>(GetInvoiceReport2(currentContractId, currentReportDateId));
    dispatch<any>(GetHseReport(currentContractId, currentReportDateId));
    dispatch<any>(GetProgressStateReport(currentContractId, currentReportDateId));
    dispatch<any>(GetBudgetCostReport(currentContractId, currentReportDateId));
    dispatch<any>(GetMachineryReport(currentContractId, currentReportDateId));
    dispatch<any>(GetProjectPersonalReport(currentContractId, currentReportDateId));
  }, [dispatch, currentContractId, currentReportDateId])

  const setReportVisits = (reportId: number) => {
    const request: IRequestReportVisit = {
      contractid: currentContractId,
      dateid: currentReportDateId,
      userid: userid,
      reportid: reportId,
  }
    dispatch<any>(SetReportVisit(request))
  }

  // console.log('---permissions: ', permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
  //                         permissions.some((p: { permission: string; }) => p.permission === 'Projects Images Reports R')))
  return(
    <Sidebar  
      rtl={false} 
      breakPoint="sm"
      transitionDuration={800} 
      style={{ 
        height: "100vh",
        borderLeft:'.4px solid rgb(214, 216, 216)',
      }}
      backgroundColor={colorMode !== 'dark' ? 'rgb(222, 235, 243)' : '#0d1e31'}
      dir={rtl ? 'rtl' : 'ltr'}
      rootStyles={{
        color: colorMode !== 'dark' ? '#000' : '#fff',
        fontFamily:'B Nazanin',
      }} 
    >
      <Menu 
      >
        <MenuItem 
          style={{ 
            backgroundColor: 'rgba(77, 144, 252, 0.1)',
            borderBottom: '.2px solid rgb(214, 216, 216)',
            // 'rgb(202, 243, 243)', 
            textAlign: "center", 
            height: 68, 
            marginTop: 0,
          }}
          icon={<MenuOutlined 
                  sx={{color: 'inherit'}}
                />}
          onClick={() => {
            toggle();
          }}
        >
          {" "}
          <Typography 
            sx={{textAlign:"center", fontWeight:"bold", color: 'inherit'}} 
            variant="h6"
          >
            PMRS
          </Typography>
        </MenuItem>
      </Menu>
      <Box sx={{ p: '0 24px', mb: '8px', mt: '8px' }}>
        <Typography
          variant="body1"
          fontWeight={600}
          sx={{ opacity: collapsed ? 0 : 0.8, letterSpacing: '0.5px', fontFamily:'B Nazanin', fontSize:'1em'}}
        >
          اطلاعات پروژه
        </Typography>
      </Box>
      <Menu menuItemStyles={menuItemStyles}>
        <MenuItem 
          icon={<HomeOutlined />} 
          component={<Link to="/" />}
          active={window.location.pathname === "/"}
          onMouseUp={() => menuItemMouseUpHandler('اطلاعات کلی پروژه')}
        >
          اطلاعات کلی پروژه
        </MenuItem>
        <SubMenu icon={<FactoryOutlined />} label="اطلاعات ماهانه پروژه">
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                    permissions.some((p: { permission: string; }) => p.permission === 'Financial Info R') || 
                                    permissions.some((p: { permission: string; }) => p.permission === 'Financial Info R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 1 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 1 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }
              component={<Link to="/project/financialInfo" />}
              active={window.location.pathname === "/project/financialInfo"}
              onMouseUp={() => (
                (board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Financial Info R')) ?
                    setReportVisits(1) : '',
                menuItemMouseUpHandler('اطلاعات مالی')
              )}
            >اطلاعات مالی</MenuItem>
          } 
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'HSE R') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'HSE R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 2 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 2 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/hse" />}
              active={window.location.pathname === "/project/hse"}
              onMouseUp={() => (
                (board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'HSE R')) ?
                    setReportVisits(2) : '',
                menuItemMouseUpHandler('HSE')
              )}            
              >HSE</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'Progress State R') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'Progress State R/W')) && 
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 3 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 3 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/progressState" />}
              active={window.location.pathname === "/project/progressState"}
              onMouseUp={() => (
                (board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Progress State R')) ?
                    setReportVisits(3) : '',
                menuItemMouseUpHandler('گزارش وضعیت پیشرفت پروژه در حال حاضر')
              )}            
              >وضعیت پیشرفت</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') ||   
                                      permissions.some((p: { permission: string; }) => p.permission === 'Time Progress State R') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'Time Progress State R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 4 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 4 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/timeProgress" />}
              active={window.location.pathname === "/project/timeProgress"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Time Progress State R')) 
                    setReportVisits(4);
                menuItemMouseUpHandler('گزارش وضعیت پیشرفت زمانی پروژه در حال حاضر');
              }}              
              >وضعیت پیشرفت زمانی</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'Invoices R') || 
                                      permissions.some((p: { permission: string; }) => p.permission === 'Invoices R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 5 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 5 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/invoice" />}
              active={window.location.pathname === "/project/invoice"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Invoices R')) 
                    setReportVisits(5) ;
                menuItemMouseUpHandler('صورت وضعیت');
              }}               
              >صورت وضعیتها</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                               permissions.some((p: { permission: string; }) => p.permission === 'Invoice Financial R') || 
                               permissions.some((p: { permission: string; }) => p.permission === 'Invoice Financial R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 6 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 6 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/invoiceFinancial" />}
              active={window.location.pathname === "/project/invoiceFinancial"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Invoice Financial R')) 
                    setReportVisits(6) ;
                menuItemMouseUpHandler('صورت وضعیت مالی');
              }}             
            >صورت وضعیتها مالی</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Work Volume Done R') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Work Volume Done R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 7 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 7 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/workVolume" />}
              active={window.location.pathname === "/project/workVolume"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Work Volume Done R')) 
                    setReportVisits(7);
                menuItemMouseUpHandler('شرح احجام انجام شده تا کنون');
              }}             
            >احجام انجام شده</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                    permissions.some((p: { permission: string; }) => p.permission === 'PMS Progress R') || 
                                    permissions.some((p: { permission: string; }) => p.permission === 'PMS Progress R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 8 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 8 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/project/pmsProgress" />}
              active={window.location.pathname === "/project/pmsProgress"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'PMS Progress R')) 
                    setReportVisits(8);
                menuItemMouseUpHandler('PMS درصدهای پیشرفت مطابق ');
              }}             
            >PMS</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                          permissions.some((p: { permission: string; }) => p.permission === 'Budget R') || 
                                          permissions.some((p: { permission: string; }) => p.permission === 'Budget R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 9 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 9 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/project/budget" />}
              active={window.location.pathname === "/project/budget"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Budget R')) 
                    setReportVisits(9);
                menuItemMouseUpHandler('بودجه مصوب و هزینه های تجمعی');
              }}                           
            >بودجه مصوب</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                       permissions.some((p: { permission: string; }) => p.permission === 'Machinary R') || 
                                       permissions.some((p: { permission: string; }) => p.permission === 'Machinary R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 10 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 10 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/project/machinery" />}
              active={window.location.pathname === "/project/machinery"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Machinary R')) 
                    setReportVisits(10);
                menuItemMouseUpHandler(' اهم ماشین آلات');
              }} 
            >ماشین آلات</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Project Personel R') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Project Personel R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 11 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 11 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/project/personal" />}
              active={window.location.pathname === "/project/personal"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Project Personel R')) 
                    setReportVisits(11);
                menuItemMouseUpHandler('نیروی انسانی ستادی و اجرایی');
              }}               
            >منابع انسانی</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Problems R') || 
                                permissions.some((p: { permission: string; }) => p.permission === 'Problems R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 12 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 12 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/project/problems" />}
              active={window.location.pathname === "/project/problems"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Problems R')) 
                    setReportVisits(12);
                menuItemMouseUpHandler('مشکلات و موانع پیشبرد پروژه');
              }} 
            >موانع و مشکلات</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                 permissions.some((p: { permission: string; }) => p.permission === 'Critical Action R') || 
                                 permissions.some((p: { permission: string; }) => p.permission === 'Critical Action R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 13 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 13 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/project/criticalActions" />}
              active={window.location.pathname === "/project/criticalActions"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Critical Action R')) 
                    setReportVisits(13);
                menuItemMouseUpHandler('فعالیتهای بحرانی و اصلی ماه آینده');
              }}               
            >فعالیتهای بحرانی</MenuItem>
          }
        </SubMenu>
        <SubMenu icon={<ImageOutlined />} label="تصاویر سازه ها و اسناد">
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                            permissions.some((p: { permission: string; }) => p.permission === 'Zone R') || 
                                            permissions.some((p: { permission: string; }) => p.permission === 'Zone R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 14 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 14 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/documents/constructionImages" />}
              active={window.location.pathname === "/documents/constructionImages"}
              onMouseUp={() => {
                if(board && permissions.length > 0 &&    
                  permissions.some((p: { permission: string; }) => p.permission === 'Zone R')) 
                    setReportVisits(14);
                menuItemMouseUpHandler('سازه های پروژه');
              }} 
            >سازه ها</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                               permissions.some((p: { permission: string; }) => p.permission === 'Project Documents R') || 
                               permissions.some((p: { permission: string; }) => p.permission === 'Project Documents R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 15 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 15 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }              
              component={<Link to="/documents/projectDocuments" />}
              active={window.location.pathname === "/documents/projectDocuments"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Project Documents R')) 
                    setReportVisits(15);
                menuItemMouseUpHandler('اسناد پروژه');
              }} 
            >اسناد پروژه</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                              permissions.some((p: { permission: string; }) => p.permission === 'Periodic Documents R') || 
                              permissions.some((p: { permission: string; }) => p.permission === 'Periodic Documents R/W')) &&
            <MenuItem 
              icon={
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 16 && c.user_c && c.pm_c))  
                ?
                <CheckCircle sx={{color:"green"}}/>      
                :
                confirmedReports && confirmedReports.length > 0 && (confirmedReports.some((c: {
                  type: number,
                  user_c: boolean,
                  pm_c: boolean,
                }) => c.type === 16 && c.user_c && !c.pm_c)) 
                ?   
                <CheckCircle sx={{color:"yellow"}}/>       
                :
                <CancelRounded sx={{color:"red"}}/>
              }               
              component={<Link to="/documents/durationDocuments" />}
              active={window.location.pathname === "/documents/durationDocuments"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Periodic Documents R')) 
                    setReportVisits(16);
                menuItemMouseUpHandler('اسناد دوره ای');
              }} 
              >اسناد دوره ای</MenuItem>
          }
        </SubMenu>
        <Box sx={{ p: '0 24px', mb: '8px', mt: '8px' }}>
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ opacity: collapsed ? 0 : 0.8, letterSpacing: '0.5px', fontFamily:'B Nazanin', fontSize:'1em'}}
          >
            گزارشات
          </Typography>
        </Box>
        <SubMenu icon={<DashboardOutlined />} label="گزارشهای مدیریتی" onMouseDown={() => retrieveDashboardData()}>
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                                  permissions.some((p: { permission: string; }) => p.permission === 'Dashboard Report R')) &&
            <MenuItem 
              component={<Link to="/report/managementReport" />}
              active={window.location.pathname === "/report/managementReport"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Dashboard Report R')) 
                    setReportVisits(17);
                menuItemMouseUpHandler('داشبورد مدیریتی');
              }} 
            >داشبورد مدیریتی</MenuItem>
          }
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                              permissions.some((p: { permission: string; }) => p.permission === 'Dashboard Report FC R')) &&
            <MenuItem 
              component={<Link to="/report/managementReport_fc" />}
              active={window.location.pathname === "/report/managementReport_fc"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Dashboard Report FC R')) 
                    setReportVisits(18);
                menuItemMouseUpHandler('داشبورد مدیریتی');
              }}             
            >داشبورد مدیریتی ارزی</MenuItem>
          }
        </SubMenu>
        <SubMenu icon={<ImageOutlined />} label="گزارش تصاویر سازه ها">
          {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin') || 
                          permissions.some((p: { permission: string; }) => p.permission === 'Projects Images Reports R')) &&
            <MenuItem 
              component={<Link to="/report/constructionImagesReport" />}
              active={window.location.pathname === "/report/constructionImagesReport"}
              onMouseUp={() => {
                if(board && permissions.length > 0 && 
                  permissions.some((p: { permission: string; }) => p.permission === 'Projects Images Reports R')) 
                    setReportVisits(19);
                menuItemMouseUpHandler('گزارش تصاویر سازه ها');
              }}               
            >گزارش تصاویر سازه ها</MenuItem>
          }
        </SubMenu>
        <SubMenu icon={<ViewArrayOutlined />} label="گزارش بازدید ها">
          <MenuItem 
            onClick={() => navigate('/report/siteVisitReport', { replace: true })}
            onMouseUp={() => menuItemMouseUpHandler('گزارش بازدید ها')}>گزارش بازدید ها</MenuItem>
        </SubMenu>
        <Box sx={{ py: '0', px:'24px', mb: '8px', mt: '15px' }}>
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ opacity: collapsed ? 0 : 0.8, letterSpacing: '0.5px', fontFamily:'B Nazanin', fontSize:'1em'}}
          >
            امنیت
          </Typography>
        </Box>
        <SubMenu icon={<SecurityOutlined />} label="امنیت">
          <MenuItem onClick={() => {
            dispatch<any>(ActivateChangeUserPassword(true));
            navigate('auth/changepassword', { replace: true });
          }}
            onMouseUp={() => menuItemMouseUpHandler('تغییر کلمه عبور')}>تغییر کلمه عبور</MenuItem>
        </SubMenu>
        {permissions.length > 0 && (permissions.some((p: { permission: string; }) => p.permission === 'System Admin')) &&
        <>
          <Box sx={{ py: '0', px:'24px', mb: '8px', mt: '15px' }}>
            <Typography
              variant="body1"
              fontWeight={600}
              sx={{ opacity: collapsed ? 0 : 0.8, letterSpacing: '0.5px', fontFamily:'B Nazanin', fontSize:'1em'}}
            >
              مدیر سامانه
            </Typography>
          </Box>
          <SubMenu icon={<SecurityOutlined />} label="مدیر سامانه">
            <MenuItem component={<Link to="https://pmrsapi.asft.co:443/api/control_panel/" target="blank" style={{textDecoration:'none', fontFamily:'B Nazanin'}}/>} icon={<AdminPanelSettingsOutlined />}>
              پنل مدیر سامانه
            </MenuItem>
          </SubMenu>
        </>
        }
      </Menu>
    </Sidebar>
  );
};


export default SideBar;